import { isVariantPurchasable, resolvePurchasableVariant } from "@/lib/products/purchasable-variant";

export interface StackBuilderVariantChoice {
	variantId: string;
	quantity: number;
}

/** Mirrors the cart route's validated 1..10 quantity contract. */
export const STACK_BUILDER_QUANTITY_MAX = 10;

export function clampStackBuilderQuantity(quantity: number): number {
	if (!Number.isFinite(quantity)) return 1;
	return Math.min(STACK_BUILDER_QUANTITY_MAX, Math.max(1, Math.trunc(quantity)));
}

export function isStackBuilderVariantPurchasable(variant: unknown): boolean {
	if (!variant || typeof variant !== "object") return false;
	const record = variant as Record<string, unknown>;
	if (typeof record.id !== "string" || record.id.trim().length === 0) return false;
	return isVariantPurchasable(
		record as {
			id: string;
			name: string;
			quantityAvailable?: number | null;
			pricing?: { price?: { gross?: { amount?: number | null } | null } | null } | null;
		},
	);
}

/** Request-time availability gate shared by quiz handoff and manual stack selection. */
export function getStackBuilderDefaultVariant(product: unknown): StackBuilderVariantChoice | null {
	const record = product as Record<string, unknown> | null;
	if (
		!record ||
		record.isAvailable === false ||
		!Array.isArray(record.variants) ||
		record.variants.length === 0
	) {
		return null;
	}

	const resolution = resolvePurchasableVariant(
		record.variants as Array<{
			id: string;
			name: string;
			quantityAvailable?: number | null;
			pricing?: { price?: { gross?: { amount?: number | null } | null } | null } | null;
			selectionAttributes?: Array<{
				attribute?: { slug?: string | null } | null;
				values?: Array<{ name?: string | null; value?: string | null }> | null;
			}> | null;
		}>,
	);

	return resolution.variant &&
		resolution.isPurchasable &&
		isStackBuilderVariantPurchasable(resolution.variant)
		? { variantId: resolution.variant.id, quantity: 1 }
		: null;
}
